// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  GamesLeaderboardEntryDto,
  LeaderboardQueryDto,
  MatchReadAllDto,
  MatchReturnDto,
  StreakLeaderboardEntryDto,
  WinningsLeaderboardEntryDto,
  IBaseArrayResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class MatchService {
  /**
   * GET /api/match
   */
  readAll(
    dto: MatchReadAllDto,
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<MatchReturnDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/match';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      configs.params = dto;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/match/leaderboard/games
   */
  getGamesLeaderboard(
    dto: LeaderboardQueryDto,
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<GamesLeaderboardEntryDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/match/leaderboard/games';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      configs.params = dto;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/match/leaderboard/winnings
   */
  getWinningsLeaderboard(
    dto: LeaderboardQueryDto,
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<WinningsLeaderboardEntryDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/match/leaderboard/winnings';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      configs.params = dto;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/match/leaderboard/streaks
   */
  getStreakLeaderboard(
    dto: LeaderboardQueryDto,
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<StreakLeaderboardEntryDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/match/leaderboard/streaks';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      configs.params = dto;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
